import WebApiService from '../services/WebApiService';

export default class ReportingService extends WebApiService {

    constructor() {
        super();

        this.post = super.post.bind(this);
        this.get = super.get.bind(this);
    }

    run(payload, successCallback, errorCallback) {
        this.post('/api/Reporting/Run', payload, successCallback, errorCallback);
    }

    sendEmails(payload, successCallback, errorCallback) {
        this.post('/api/Reporting/SendEmails', payload, successCallback, errorCallback);
    }

    reRun(payload, successCallback, errorCallback) {
        this.post('/api/Reporting/ReRun', payload, successCallback, errorCallback);
    }

    getList(companyId, successCallback, errorCallback) {
        this.get('/api/Reporting/GetList/' + companyId, successCallback, errorCallback);
    }

    getMetadata(reportId, successCallback, errorCallback) {
        this.get('/api/Reporting/GetMetadata/' + reportId, successCallback, errorCallback);
    }

    getRuns(reportId, companyId, successCallback, errorCallback) {
        this.get('/api/Reporting/GetRuns/' + reportId + "/" + companyId, successCallback, errorCallback);
    }

    deleteRun(reportRunId, successCallback, errorCallback) {
        this.get('/api/Reporting/DeleteRun/' + reportRunId, successCallback, errorCallback);
    }

    download(reportRunId, successCallback, errorCallback) {
        this.get('/api/Reporting/Download/' + reportRunId, successCallback, errorCallback);
    }

    reportComplete(reportRunId, successCallback, errorCallback) {
        this.get('/api/Reporting/ReportComplete/' + reportRunId, successCallback, errorCallback);
    }

    genericGet(uri, successCallback, errorCallback) {
        this.get('/api/Reporting/' + uri, successCallback, errorCallback)
    }
}